import StorySlide from './story'
export default StorySlide
